<style scoped lang="less">
.price {
  font-size: 20px;
  color: red;
}

.sold-num {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.slod-num > span:not(:first-child) {
  padding-left: 20px;
}

.van-cell__value {
  margin-right: -16px;
}

.detail {
  line-height: 0;
}

/deep/ #detail  img{
  width: 100% ;
}

/deep/.van-sku-actions {
  /deep/.van-button--danger {
    background: #ffc053;
  }
}
.warp {
  padding-bottom: 50px;
}
</style>

<template>
  <div>
    <div v-if="!showPage">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </div>
    <div class="warp" v-else>
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(banner, index) in ImageList" :key="index">
          <img class="swipe-img" width="100%" v-lazy="banner" />
        </van-swipe-item>
      </van-swipe>

      <van-cell size="large">
        <template #title>
          <span class="price">
            <span style="font-size: 12px">￥</span>
            <span v-if="price.length > 1"
              >{{ (price[0] / 100).toFixed(2) }}~{{
                (price[price.length - 1] / 100).toFixed(2)
              }}</span
            >
            <span v-if="price.length == 1">{{
              (price[0] / 100).toFixed(2)
            }}</span>
          </span>
          <br />
          <span class="desc">{{ product.Name }}</span>
        </template>

        <template #default>
          <van-tag
            @click="toShare()"
            style="border-radius: 15px 0 0 15px; padding-right: 15px"
            type="warning"
            size="large"
          >
            <van-icon name="share" />分享
          </van-tag>
        </template>

        <template #label>
          <div class="slod-num">
            <span>销量：{{ product.SoldNum }}</span>
            <span>库存：{{ product.Stock }}</span>
          </div>
        </template>
      </van-cell>

      <van-sku
        v-model="show"
        :sku="sku"
        :goods="goods"
        :goods-id="goodsId"
        :quota="quota"
        :initial-sku="initialSku"
        :quota-used="quotaUsed"
        :hide-stock="sku.hide_stock"
        :show-add-cart-btn="false"
        buy-text="加入购物车"
        @buy-clicked="onAddCartClicked"
      />

      <div class="detail" id="detail" v-html="product.Detail"></div>

      <van-goods-action>
        <van-goods-action-icon
          @click="toPage('home')"
          icon="home-o"
          text="首页"
        />
        <van-goods-action-icon
          v-if="isCollection"
          @click="toCollect(1)"
          icon="star"
          color="red"
          text="取消收藏"
        />
        <van-goods-action-icon
          v-else
          @click="toCollect(0)"
          icon="star-o"
          color="red"
          text="收藏"
        />
        <van-goods-action-icon
          @click="toPage('cart')"
          v-if="cartNum > 0"
          icon="cart-o"
          :badge="cartNum"
          text="购物车"
        />
        <van-goods-action-icon
          @click="toPage('cart')"
          v-else
          icon="cart-o"
          text="购物车"
        />
        <van-goods-action-button
          @click="showCartDetail"
          type="warning"
          text="加入购物车"
        />
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Button,
  Image as VanImage,
  Tag,
  Icon,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Cell,
  CellGroup,
  Grid,
  GridItem,
  Skeleton,
  Sku,
} from "vant";
import api from "../../api/product";
export default {
  components: {
    [Swipe.name]: Swipe,
    [Button.name]: Button,
    [VanImage.name]: VanImage,
    [Tag.name]: Tag,
    [SwipeItem.name]: SwipeItem,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Sku.name]: Sku,
    [Skeleton.name]: Skeleton,
    [Icon.name]: Icon,
  },
  name: "product",
  props: {
    msg: String,
  },
  data() {
    return {
      price: [],
      product: {},
      ImageList: [],
      cartNum: 0,
      showPage: false,
      isCollection: false,
      show: false,
      // 限购数，0 表示不限购
      quota: 0,
      // 购买过产品
      quotaUsed: 0,
      goodsId: this.$route.query.id,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
          {
            k: "规格", // skuKeyName：规格类目名称
            v: [
              {
                id: "123", // skuValueId：规格值 id
                name: "15KG/包", // skuValueName：规格值名称
                imgUrl:
                  "http://img.riceyfy.com/attachment/images/4/2017/12/DrqY2lA2yrHu49985aUl55h32r7HUZ.jpg", // 规格类目图片，只有第一个规格类目可以定义图片
                previewImgUrl:
                  "http://img.riceyfy.com/attachment/images/4/2017/12/DrqY2lA2yrHu49985aUl55h32r7HUZ.jpg", // 用于预览显示的规格类目图片
              },
              {
                id: "1215",
                name: "30KG/包",
                imgUrl:
                  "http://img.riceyfy.com/attachment/images/4/2017/12/PX1qmr66lqDClCcYcy4TQRCYM4YRC4.png",
                previewImgUrl:
                  "http://img.riceyfy.com/attachment/images/4/2017/12/PX1qmr66lqDClCcYcy4TQRCYM4YRC4.png",
              },
            ],
            k_s: "s1", // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
          },
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [
          {
            id: "skuId123", // skuId，下单时后端需要
            price: 100, // 价格（单位分）
            s1: "123", // 规格类目 k_s 为 s1 的对应规格值 id
            stock_num: 1100, // 当前 sku 组合对应的库存
          },
          {
            id: "skuId2259", // skuId，下单时后端需要
            price: 1000, // 价格（单位分）
            s1: "1215", // 规格类目 k_s 为 s1 的对应规格值 id
            stock_num: 1101, // 当前 sku 组合对应的库存
          },
        ],
        price: "100.00", // 默认价格（单位元）
        stock_num: 0, // 商品总库存
        collection_id: "skuId123", // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品
        hide_stock: false, // 是否隐藏剩余库存
      },
      goods: {
        picture:
          "http://img.riceyfy.com/attachment/images/4/2017/12/DrqY2lA2yrHu49985aUl55h32r7HUZ.jpg",
      },
      initialSku: {
        // 键：skuKeyStr（sku 组合列表中当前类目对应的 key 值）
        // 值：skuValueId（规格值 id）
        s1: "215",
        // 初始选中数量
        selectedNum: 1,
      },
    };
  },

  mounted() {},
  created() {
    let id = this.$route.query.id;
    let bannerList = [];
    api.item({ id }).then((res) => {
      console.log(res);
      if (res.status == 0) {
        this.product = res.result;
        // this.ImageList = JSON.parse(this.product.ImageList);
        let price = [];
        let v = [];
        let list = [];
        this.product.itemOption.forEach((element) => {

            element.Image&&element.Image.indexOf('http')==-1?element.Image='https://www.riceyfy.com'+element.Image:''
            element.ImageBack&&element.ImageBack.indexOf('http')==-1?element.ImageBack='https://www.riceyfy.com'+element.ImageBack:''

          element.Image ? bannerList.push(element.Image) : "";
          element.ImageBack ? bannerList.push(element.ImageBack) : "";

          if (element.Status > 0) {
            price.push(element.Price);

            v.push({
              id: element.id, // skuValueId：规格值 id
              name: `${element.Weight}${element.Unit}`, // skuValueName：规格值名称
              imgUrl: element.Image, // 规格类目图片，只有第一个规格类目可以定义图片
              previewImgUrl: element.Image,
            });

            list.push({
              id: element.id, // skuId，下单时后端需要
              price: Number(element.Price), // 价格（单位分）
              s1: element.id, // 规格类目 k_s 为 s1 的对应规格值 id
              stock_num: element.Stock, // 当前 sku 组合对应的库存
            });
          }
        });
        this.ImageList=bannerList
        console.log('banner',this.ImageList)
        // 排列规格价格  去最大 最小
        price.sort((a, b) => {
          return a - b;
        });
        this.price = price;
        let sku = this.sku;
        sku.tree[0].v = v;
        sku.list = list;

        sku.price = (price[0] / 100).toFixed(2);
        console.log("product", this.product);
        sku.stock_num = this.product.Stock;
        this.initialSku.s1 = this.product.itemOption[0].id;
        this.goods.picture = this.product.itemOption[0].Image;
        console.log(sku);
        this.showPage = true;
      }
    });

    // 收藏
    api.isCollection({ ProductId: this.$route.query.id }).then((res) => {
      this.isCollection = res.status == 0 && res.result;
    });

    this.getCartNum();
  },
  methods: {
    getCartNum() {
      api.getCartItemNum().then((res) => {
        if (res.status == 0) {
          this.cartNum = res.result;
        }
      });
    },
    onChange() {
      console.log(1);
    },
    // 商品页面跳转
    toPage(name) {
      this.$router.push({ name });
    },
    // 分享
    toShare() {
      this.$toast("点击右上角分享");
    },
    // 收藏
    toCollect(val) {
      if (val) {
        api
          .collectionDelete({ ProductId: this.$route.query.id })
          .then((res) => {
            if (res.status == 0) {
              this.$toast.success("取消收藏");
              this.isCollection = false;
            } else {
              this.$toast.fail("操作失败");
            }
          });
      } else {
        api.collectionAdd({ ProductId: this.$route.query.id }).then((res) => {
          if (res.status == 0) {
            this.$toast.success("收藏成功");
            this.isCollection = true;
          } else {
            this.$toast.fail("操作失败");
          }
        });
      }
    },
    showCartDetail() {
      this.show = true;
    },
    onAddCartClicked(e) {
      console.log(e);
      let params = {
        ItemId: e.goodsId,
        OptionId: e.selectedSkuComb.id,
        Num: e.selectedNum,
      };
      api.addCartItem(params).then((res) => {
        if (res.status == 0) {
          this.$toast.success("加入成功");
          this.getCartNum();
        } else {
          this.$toast.fail("操作失败");
        }
        this.show = false;
      });
      console.log(params);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


